var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bmap-component"},[_c('div',{ref:"bmap",staticClass:"bmap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }